import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#651A75] text-gwa-bg gwa-noise">
      <div className="gwa-container py-20 lg:py-28 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="gwa-eyebrow-light"><span className="gwa-rule" />Executive Leadership Advisory</p>
            <h3 className="font-serif text-4xl lg:text-5xl mt-6 leading-[1.05]">
              Build leaders the<br />organisation actually needs.
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta-pipeline"
              className="inline-flex items-center gap-3 mt-10 text-sm uppercase tracking-[0.18em] font-semibold border-b border-gwa-gold pb-2 hover:gap-5 transition-all"
            >
              Discuss your leadership pipeline <ArrowUpRight className="w-4 h-4 text-gwa-gold" />
            </Link>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <p className="gwa-eyebrow-light mb-5"><span className="gwa-rule" />Navigate</p>
            <ul className="space-y-3 text-sm text-gwa-bg/80">
              <li><Link className="hover:text-gwa-accent transition-colors" to="/corporate">Corporate Solutions</Link></li>
              <li><Link className="hover:text-gwa-accent transition-colors" to="/programmes">Programmes</Link></li>
              <li><Link className="hover:text-gwa-accent transition-colors" to="/about">About Pascale</Link></li>
              <li><Link className="hover:text-gwa-accent transition-colors" to="/coaching">For Individuals</Link></li>
              <li><Link className="hover:text-gwa-accent transition-colors" to="/contact">Enquire</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="gwa-eyebrow-light mb-5"><span className="gwa-rule" />Contact</p>
            <ul className="space-y-3 text-sm text-gwa-bg/80">
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-gwa-accent" />
                <a className="hover:text-gwa-accent transition-colors" href="mailto:hello@globalwomenascend.com">hello@globalwomenascend.com</a>
              </li>
              <li className="flex items-center gap-3">
                <Linkedin className="w-4 h-4 text-gwa-accent" />
                <a className="hover:text-gwa-accent transition-colors" href="https://www.linkedin.com/" target="_blank" rel="noreferrer">LinkedIn</a>
              </li>
              <li className="text-gwa-bg/60 pt-2">London, United Kingdom</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs tracking-wider text-gwa-bg/50">
            © {new Date().getFullYear()} Global Women Ascend. All rights reserved.
          </p>
          <p className="text-xs tracking-[0.2em] uppercase text-gwa-bg/40">
            Executive advisory · Leadership development · UK & Europe
          </p>
        </div>
      </div>
    </footer>
  );
}
